import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "SANITATION",
  title: defineMessage({
    id: "fig.quality.SANITATION.title",
    defaultMessage: `Availability of single-sex sanitation facilities in schools`,
  }),
  caption: defineMessage({
    id: "fig.quality.SANITATION.caption",
    defaultMessage: `In poorer countries, a majority of primary schools do not have single-sex (or even any) sanitation facilities.`,
  }),
  source: defineMessage({
    id: "fig.quality.SANITATION.source",
    defaultMessage: `UIS database`,
  }),
};
